import React, { useEffect } from "react";
import { Edit, ChevronDown, ChevronRight } from "lucide-react";
import { useLocation, useParams } from "react-router-dom";

import MainContainer from "../../components/container/MainContainer";
import { useDispatch, useSelector } from "react-redux";
import {
  getStatusTasks,
  setSelectedTask,
  toggleOpen,
} from "../../features/tasksSlice";
import { openModal } from "../../features/modalSLice";
import Modal from "../../components/modal/Modal";
import AddTaskRecord from "./AddTaskRecord";
import EditTask from "./EditTask";
import { getProject } from "../../features/projectsSlice";
import Loading from "../../components/loading/Loading";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";

const Task = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const modalContent = useSelector((state) => state.modal.content);
  const selectedProject = useSelector((state) => state.projects.selected);
  let tasks2 = useSelector((state) => state.tasks.data);
  const statusTaskLoad = useSelector(
    (state) => state.tasks.load.getStatusTasks
  );
  const projectLoad = useSelector((state) => state.projects.load.getProject);
  const { id } = useParams();

  //When  Status is clicked
  const openTaskModal = (e, task) => {
    e.preventDefault();
    if (task.id) {
      dispatch(setSelectedTask(task));
    }
    dispatch(openModal(<EditTask />));
  };

  //When Edit button is clicked
  const openAddTaskRecordModal = (e, task) => {
    e.preventDefault();
    if (task.id) {
      dispatch(setSelectedTask(task));
    }
    dispatch(openModal(<AddTaskRecord />));
  };

  useEffect(() => {
    dispatch(getStatusTasks(id));
    dispatch(getProject(id));
  }, []);

  useEffect(() => {}, [tasks2]);

  if (
    statusTaskLoad === loadStatus.loading ||
    projectLoad === loadStatus.loading
  ) {
    return <Loading />;
  }
  if (statusTaskLoad === loadStatus.error || projectLoad === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer className="flex-1 p-6 ">
      <Modal>{modalContent}</Modal>
      <div className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-text-1/90">Task List</h2>
        <h4 className="pb-4">
          {selectedProject.title ? selectedProject.title : ""}
        </h4>
        <div className="hidden md:block">
          <table className="task-table -full table-fixed border-collapse">
            <thead className="border-none">
              <tr className="border-none text-text-1/90">
                <th className="w-1/12 p-2  bg-bkg2 rounded-l-md">#</th>
                <th className="w-4/12 p-2  bg-bkg2">Task Name</th>
                <th className="w-2/12 p-2  bg-bkg2">Task Tags</th>
                <th className="w-1/12 p-2  bg-bkg2">Hours</th>
                <th className="w-2/12 p-2  bg-bkg2">Task Assign</th>
                <th className="w-2/12 p-2  bg-bkg2">Due Date</th>
                <th className="w-1/12 p-2  bg-bkg2 rounded-r-md ">Actions</th>
              </tr>
            </thead>
            <tbody>
              {tasks2.map((item, index) => (
                <React.Fragment key={index}>
                  <tr className="">
                    <td colSpan="7" className="mt-3 ">
                      <div className="flex justify-start items-center  mt-6 bg-primary/55 py-2 px-1 gap-3 rounded-md">
                        <button
                          className="p-0.5 bg-text-gen rounded-md t"
                          onClick={() => dispatch(toggleOpen(item.id))}
                        >
                          {item.isOpen ? <ChevronDown /> : <ChevronRight />}
                        </button>
                        <span className="text-text-gen">
                          {item.name.toLowerCase() === "pending"
                            ? "To Do"
                            : "In Progress"}
                        </span>
                      </div>
                    </td>
                  </tr>

                  {item.isOpen &&
                    item.tasks.map((task, index) => (
                      <tr key={index} className="border-none text-text-1/70">
                        <td className="p-1.5  rounded-l-md">{index + 1}</td>
                        <td className="p-1.5 ">
                          <span>{task.task_template.name}</span>
                        </td>
                        <td className="p-1.5 ">
                          <span
                            className="p-0.5 rounded-md flex items-center justify-center text-text-gen/75"
                            style={{ backgroundColor: item.color }}
                          >
                            {item.name}
                          </span>
                        </td>
                        <td className="p-1.5 ">{task.hours}</td>
                        <td className="p-1.5 ">{`${task.user?.last_name[0]}. ${task.user?.first_name}`}</td>
                        <td className="p-1.5 ">{task.due}</td>
                        <td className="p-1.5  rounded-r-md">
                          <button
                            onClick={(e) => openAddTaskRecordModal(e, task)}
                            type="button"
                          >
                            <Edit className="rounded-md hover:bg-bkg2 hover:text-text-1/95 cursor-pointer" />{" "}
                          </button>
                        </td>
                      </tr>
                    ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile View */}
        <div className="block md:hidden text-text-1">
          {tasks2.map((item, index) => (
            <div key={index} className="bg-bkg p-4 mb-4 rounded shadow">
              <div className="flex justify-start items-center cursor-pointer bg-primary/65 rounded-md gap-4 py-2 px-1">
                <button onClick={() => dispatch(toggleOpen(item.id))}>
                  {item.isOpen ? <ChevronDown /> : <ChevronRight />}
                </button>
                <span>
                  {item.name.toLowerCase() === "pending"
                    ? "To Do"
                    : "In Progress"}
                </span>
              </div>
              {item.isOpen && (
                <div>
                  {item.tasks.map((task, index) => (
                    <div
                      key={index}
                      className="bg-content p-4 mb-4 rounded shadow text-text-1/75"
                    >
                      <div className="flex justify-between items-center ">
                        <div>
                          <span className="font-bold">{index + 1}.</span>

                          <span>{task.task_template.name}</span>
                        </div>
                        <button
                          type="button"
                          onClick={(e) => openAddTaskRecordModal(e, task)}
                        >
                          <Edit className="text-gray-500 cursor-pointer" />
                        </button>
                      </div>
                      <div className="flex justify-between mt-2">
                        <span
                          className="px-3 rounded-md flex items-center justify-center text-text-gen/75"
                          style={{ backgroundColor: item.color }}
                        >
                          {item.name}
                        </span>
                        <span>{task.hours} hours</span>
                      </div>
                      <div className="flex justify-between mt-2">
                        <span>{`${task.user.last_name[0]}. ${task.user.first_name}`}</span>
                        <span>{task.due}</span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </MainContainer>
  );
};

export default Task;
